import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from 'app/public/services/subscription.service';

import { Language, SiteDocsUrl} from 'app/shared/model/enums';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
  changeDetection:ChangeDetectionStrategy.OnPush
  
})
export class PrivacyPolicyComponent implements OnInit {
  pdfSrc: string
  language: Language;
   docType:SiteDocsUrl;
   Language=Language;
  constructor(private route:ActivatedRoute,private _service:SubscriptionService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.language = params['language'] || null;
    });
   if(this.language==Language.he)
     this.docType=SiteDocsUrl.PrivacyPolicyHebrew
    else
    this.docType=SiteDocsUrl.PrivacyPolicyEnglish
  this._service.getSiteDocUrl(this.docType).subscribe(
    succ=>{
      this.pdfSrc=succ
      this.cdr.markForCheck()
    }
  )
  }
}
